import { render } from "./CarouselTrap.vue?vue&type=template&id=0a32a885"
import script from "./CarouselTrap.vue?vue&type=script&lang=js"
export * from "./CarouselTrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/CarouselTrap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a32a885"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a32a885', __exports__)) {
    api.reload('0a32a885', __exports__)
  }
  
  module.hot.accept("./CarouselTrap.vue?vue&type=template&id=0a32a885", () => {
    api.rerender('0a32a885', render)
  })

}


export default __exports__